/* eslint-disable import/prefer-default-export */

export const log = (err) => {
  if (!window.console) {
    return;
  }

  /* eslint-disable no-console */
  (console.error || console.log)(err); /* eslint-enable no-console */
};



// WEBPACK FOOTER //
// ./src/modules/errors.js